module.exports = __webpack_public_path__ + "static/media/y .bf1f96bd.svg";